import { SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';

export const configurationTransferPermissionsMap = {
    'configuration-transfer': {
        group: 'System',
        label: 'Export and Import Configuration',
    },
} as const satisfies SystemPermissionDef;
